/* eslint-disable global-require */
import { LOCALES } from '../constants';

export default {
    locale: LOCALES.FRENCH,
    messages: require('./messages/fr.json'),
    addLocaleData() {
        if (!Intl.RelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/fr');
        }
        if (!Intl.PluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/fr');
        }
    },
};
